/**
 * MiscellaneousSpecs.js
 * This class is used to store miscellaneous specs for route blocking
 * allowedCountryCodes: String[]
 * settingsRequired: String[]
 * appsRequired: String[] / Enum[]
 */
export class MiscellaneousSpecs {
    allowedCountryCodes = [];
    settingsRequired = [];
    appsRequired = [];

    constructor() {
        this.allowedCountryCodes = [];
        this.settingsRequired = [];
        this.appsRequired = [];
    }
}
